<template>
    <div>
        <v-row dense>
            <v-col>
                <h4>{{ $t('totp_setup_title') }}</h4>
            </v-col>
        </v-row>
        <v-row dense>
            <v-col>
                <p class="intro">{{ $t('totp_setup_intro') }}</p>
            </v-col>
        </v-row>
        <v-row dense>
            <v-col class="text-center">
                <img v-if="qrCode" class="qr-code" :src="qrCode" :alt="$t('totp_qr_alt')" />
                <v-skeleton-loader v-else type="image" height="200" />
            </v-col>
        </v-row>
        <v-row dense>
            <v-col>
                <p class="manual-hint">{{ $t('totp_setup_manual') }}</p>
                <code class="secret">{{ groupedSecret }}</code>
            </v-col>
        </v-row>
    </div>
</template>

<script>
/**
 * TOTP onboarding: shows the QR code and the secret in readable form. The code entry
 * itself is the TotpCode component - both are displayed together during the setup.
 */
export default {
    name: 'TotpSetup',
    props: {
        /** the QR code of the otpauth URI, as an svg data-URI */
        qrCode: {
            type: String,
            default: '',
        },
        /** the base32 secret, for users who cannot scan the QR code */
        secret: {
            type: String,
            default: '',
        },
    },
    computed: {
        /**
         * The secret in blocks of four characters: much easier to type over by hand.
         */
        groupedSecret() {
            return (this.secret || '').replace(/(.{4})/g, '$1 ').trim();
        },
    },
};
</script>

<style lang="scss" scoped>
.intro,
.manual-hint {
    line-height: 1.4;
}

.qr-code {
    width: 200px;
    height: 200px;
    max-width: 100%;
}

.secret {
    display: block;
    width: 100%;
    padding: 8px;
    // Vuetify renders <code> smaller than the running text - keep it in the page flow:
    font-size: 1em;
    letter-spacing: 0.05em;
    word-break: break-all;
    text-align: center;
    background-color: #f5f5f5;
}
</style>
